export default "__VITE_ASSET__AhFDO8kb__"